export default __webpack_public_path__ + "static/media/StorySphere.314b03d8.png";